module.exports = function() {
  return new Worker(__webpack_public_path__ + "ad3431862fb0c9e40292.worker.js");
};